<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1"><a id="start">Foreword</a></h1><a id="start">
<p class="noind" style="margin-top:30px;">M<span class="small">OTHER AND DAD, LILLIAN</span> Moller Gilbreth and Frank Bunker Gilbreth, were industrial engineers. They were among the first in the scientific management field and the very first in motion study. From 1910 to 1924, their firm of Gilbreth, Inc., was employed as “efficiency expert” by many of the major industrial plants in the United States, Britain, and Germany. Dad died in 1924. After that, Mother carried the load by herself and became perhaps the foremost woman industrial engineer. But that’s another story. This book is about the Gilbreth family before Dad died.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-chap1.vue?04f6883c